module.exports = __webpack_public_path__ + "static/media/emmy_award.61041475.png";